export const DRIVER_GROUP = "Motorista";
